/* eslint-disable @typescript-eslint/no-use-before-define */
import './Modal.scss';
import cn from 'classnames';
import * as React from 'react';
// @ts-expect-error
import ReactModal from 'react-modal';
import {styled} from '@mui/material/styles';
import {BREAKPOINTS} from '../../constants/layout';
import {EscapeX} from './ui';

// See http://reactcommunity.org/react-modal/accessibility/
ReactModal.setAppElement('body');

type ModalProps = {
  children: React.ReactNode;
  close: () => void;
} & React.ComponentProps<typeof ReactModal>;

const ResponsiveModal = styled(ReactModal)({
  [`@media (max-width: ${BREAKPOINTS.MEDIUM})`]: {
    width: '100%',
    minHeight: '100%',
    margin: 0,
    borderRadius: 0,
  },
});

export function Modal({children, className, noEsc, ...props}: ModalProps) {
  return (
    <ResponsiveModal
      {...props}
      className={cn('StyledComponentModal', className)}
      onRequestClose={props.close}
      closeTimeoutMS={250}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
    >
      {!noEsc && (
        <EscapeX
          close={props.close}
          style={{
            position: 'absolute',
            top: 15,
            right: 20,
          }}
        />
      )}
      {children}
    </ResponsiveModal>
  );
}
